module.exports = __webpack_public_path__ + "img/globe_logo@2x.db69fc31.png";